import React, { useEffect } from 'react'
import { RouteComponentProps, Redirect } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'
import { createGetConstantsByKey } from 'state'
import { getCampaign, setEditingCampaign } from 'state/campaigns'
import { getTasksList, clearTasksList } from 'state/tasks'
import qs from 'query-string'
import TaskEditor from '../TaskEditor'
import { EditTaskContainer } from './styles'
import { selectCMUserUuid } from 'state/profile'
import { useCheckSomePermissions } from 'hooks/permissions'
import { CampaignManagement } from 'components/Shared/Permission/enums'
import { setTeamCountryByCampaign } from 'state/filter'

const EditTasks: React.FC<{ uuid: string }> = ({ uuid }) => {
    const dispatch = useDispatch()
    const campaignConstants = useSelector(createGetConstantsByKey('campaign'))

    useEffect(() => {
        if (uuid) {
            dispatch(
                getCampaign({
                    uuid,
                    onSuccess: campaign => {
                        dispatch(setTeamCountryByCampaign(campaign.uuid))
                    },
                }),
            )
            dispatch(getTasksList({ isMockSubmissionProof: true, campaignUuid: uuid }))
            dispatch(setEditingCampaign({ uuid: uuid as string }))
        }
    }, [dispatch, uuid])

    useEffect(() => {
        return (): void => {
            dispatch(clearTasksList())
            dispatch(setEditingCampaign({ uuid: null }))
        }
    }, [dispatch])

    return (
        <EditTaskContainer>
            {campaignConstants && campaignConstants.hasOwnProperty('task_types') ? <TaskEditor uuid={uuid} /> : null}
        </EditTaskContainer>
    )
}

const Wrapper: React.FC<RouteComponentProps> = ({ location }) => {
    const { campaign: uuid } = qs.parse(location.search)
    //this is to check if profile is loaded
    const profileUuid = useSelector(selectCMUserUuid)
    const hasCreateNewCampaignPermission = useCheckSomePermissions([
        CampaignManagement.CreateAndEditBriefsForInternal,
        CampaignManagement.CreateAndEditBriefsForExternal,
    ])
    if (profileUuid && !hasCreateNewCampaignPermission && !uuid) return <Redirect to="/403" />

    if (typeof uuid !== 'string') return null
    return <EditTasks uuid={uuid} />
}

export default Wrapper
